import Page from './Page';
import { initSwiperCarousel } from "~/components/SwiperCarousel";
import { initAutocomplete } from './home/HomeAutocomplete';
import { addSearchButtonListener } from './home/HomeSearch';
import { initHomeVenditeEvidenza } from './home/HomeVenditeEvidenza';
import { setStaticPlaceholder } from '~/utils/setStaticPlaceholder';

class Home extends Page {
    constructor() {
        super('home', 'Home Page');
    }

    public pageStart(): Promise<void> {
        this.initSwiper();
        this.initHomePage();

        return new Promise((resolve) => {
            console.log("Home page started");
            resolve();
        });
    }

    private initSwiper(): void {
        //initSwiperCarousel('.swiperBannerSlideHpDesktop', { base: 1.5, bp480: 1.5, bp576: 2, bp768: 2.5, bp992: 7, bp1200: 7, bp1400: 7, });
        initSwiperCarousel('.swiperEvidenzeSlideHpDesktop', { base: 1.5, bp480: 1.5, bp576: 2, bp768: 2.5, bp992: 3, bp1200: 4, bp1400: 4, });
        initSwiperCarousel('.swiperChiSiamoHp', { base: 1, bp480: 1, bp576: 2, bp768: 2, bp992: 4, bp1200: 3, bp1400: 4, }, true);
        initSwiperCarousel('.swiperNewsSlideHpDesktop', { base: 1.5, bp480: 1.5, bp576: 1.75, bp768: 2.25, bp992: 2.75, bp1200: 3.35, bp1400: 4, });
        //initSwiperCarousel('.swiperVetrineSlideHpDesktop', { base: 1.75, bp480: 1.75, bp576: 2.25, bp768: 2.75, bp992: 3, bp1200: 3, bp1400: 3, });
    }

    private initHomePage(): void {
        const lifestyles = ['personale', 'business'];
        lifestyles.forEach(lifestyle => {
            initAutocomplete(lifestyle);
            addSearchButtonListener(lifestyle);
            setStaticPlaceholder(`autocomplete-${lifestyle}`);
        });

        initHomeVenditeEvidenza();
    }

    public pageInit(): Promise<void> { return Promise.resolve(); }
}


export default Home